/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "YT7tQzmGRLA",
    title: "Atomic Habits by James Clear",
    description:
      "In this episode of Book Club we're talking about Atomic Habits by James Clear. We look at the power of 1% change, the importance of adopting better systems rather than setting goals, the need to focus on identity rather than outcomes and, ultimately, how to build better habits through the 4 laws",
    creator: "Ali Abdal",
    category: "Self Help",
    uploaded: "Dec 12 2021",
    comments: [
      {
        user: "Bablu Trailor",
        comment:
          "I'm about half way through the book and its worth every penny. Great video Ali 💪🏻",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment:
          "Loved this video. A brilliantly visual and fun-to-watch video summary of a must-read book!",
        color: "brown",
      },
    ],
  },
  {
    _id: "KXgBQS9Lbl8",
    title: "Books You Should Read",
    description:
      "Yo Yo Yo! Make sure you suggest some of your favourite books to me too! Lemme kno you liked the books from this video! LoveLove!",
    creator: "Mostly Sane",
    category: "Others",
    uploaded: "Jan 12 2021",
    comments: [
      {
        user: "Bablu Trailor",
        comment:
          "The diary of a young girl- by Anne Frank... I've read it in class 10 not by my choice but we're forced to",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment: "The Alchemist is a great book for a short read. Love your choices!",
        color: "brown",
      },
    ],
  },
  {
    _id: "R2BErANm_FU",
    title: "IKIGAI Book Review",
    description: "Reviewing one of my favourite books - Ikigai ,The Japanese Formula For Happiness",
    creator: "Books Amaze",
    category: "Non Fiction",
    uploaded: "May 1 2020",
    comments: [
      {
        user: "Bablu Trailor",
        comment:
          "Funny to see you talk about this book! The author is from my region and I've been reading his books since I was 13... glad to see he has readers all over the world now!",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment: "That was an amazing review. Loved the new background",
        color: "brown",
      },
    ],
  },
  {
    _id: "s6fye8WwN_4",
    title: "20 Books to read in your 20s",
    creator: "Ankur Warikoo",
    description:
      "These books have changed the way I operate, and thankfully so.If you want to change the way you operate, read, re-read and apply the learnings in these books. And you won’t regret a dime!",
    category: "Others",
    uploaded: "Apr 1 2022",
    comments: [
      {
        user: "Bablu Trailor",
        comment: "Most of those are in my top list too :) Happy Reading to.all",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment: "Hi Ankur, thank you so much for these recommendations!",
        color: "brown",
      },
    ],
  },
  {
    _id: "MA3uwVMuqAc",
    title: "5 AM Club by Robin Sharma",
    description:
      "5 Am Club by Robin Sharma || Review, Takeaways and Discussion. I bet you wanna be successful, rich and productive. 5 Am club is the solution. Join me in discussing this hyped release and grab it if you haven't already.",
    creator: "Helly",
    category: "Fiction",
    uploaded: "Mar 12 2018",
    comments: [
      {
        user: "Bablu Trailor",
        comment: "yesterday I've completed it",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment: "Just found your channel today. What an amazing job you are doing here!",
        color: "brown",
      },
    ],
  },
  {
    _id: "UOm8fJAdMig",
    title: "5 books that are for EVERYONE",
    description:
      "Yo Yo Yo! Make sure you suggest some of your favourite books to me too! Lemme kno you liked the books from this video! LoveLove!",
    creator: "Mostly Sane",
    category: "Others",
    uploaded: "Feb 12 2015",
    comments: [
      {
        user: "Bablu Trailor",
        comment: "Hello Ankur sir, I would love to read a book that taught you courage!",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment:
          "Atomic Habits!! I've come across soo many people who've read it, I would love to read it",
        color: "brown",
      },
    ],
  },
  {
    _id: "DpyMvwF4OSE",
    title: "Psychology of Money Book Review",
    description:
      "Watch this video to get know about this book. Staying wealthy is not equal being wealthy",
    creator: "Ankur Warikoo",
    category: "Self Help",
    uploaded: "Sep 13 2019",
    comments: [
      {
        user: "Bablu Trailor",
        comment:
          "I will go through this video once more & will read this book also someday. Thanks Warikoo!",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment:
          "I recently read this book and it was an eye opener for me, it completely changed my financial behaviour.",
        color: "brown",
      },
    ],
  },

  {
    _id: "c9F5kMUfFKk",
    title: "How To READ A Book A Day To CHANGE YOUR LIFE",
    description:
      "I like big books and I cannot lie! Do you want to read more? May be you have a long list of books you want to get through. I've developed a system that allows me to read 1 book a day! I want to share it with you in this video! ",
    creator: "Jay Shetty",
    category: "Others",
    uploaded: "Nov 12 2021",
    comments: [
      {
        user: "Bablu Trailor",
        comment: "Dont go hard on yourself.. Grab a book and give it time.",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment:
          "Just reading 30 minutes a day will do wonders for your memory and emotional intelligence",
        color: "brown",
      },
    ],
  },
  {
    _id: "FB2IrPqcn2Q",
    title: "Think Like A Monk Book Review",
    description:
      "In this video I have shared my views on the book Think like a monk by @Jay Shetty  I absolutely loved the book and I think it's an ideal book for beginners. ",
    creator: "Book Junction",
    category: "Non Fiction",
    uploaded: "Dec 15 2021",
    comments: [
      {
        user: "Bablu Trailor",
        comment:
          "I was also skeptical like you whether I should go for this book or not now I will definitely go for it. ",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment: "Thank you so much for giving honest review",
        color: "brown",
      },
    ],
  },
  {
    _id: "8H9jTlrpl4s",
    title: "11 Books for Beginners",
    description:
      "Hey guys, Books for Beginners are very easy to read and they are the perfect way to start reading! I made a list of Indian English Books for beginners too!",
    creator: "Helly",
    category: "Others",
    uploaded: "May 15 2000",
    comments: [
      {
        user: "Bablu Trailor",
        comment: "The Alchemist is a good recommendation too.",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment:
          "Shiva triology was amazing for a beginners like me with so many things to learn and had amazing twists",
        color: "brown",
      },
    ],
  },
  {
    _id: "zaFAsFP-u2U",
    title: "Rich Dad Poor Dad Book Review",
    description:
      "This book had so much impact on me growing up, because it fundamentally changed my equation with money, and life!",
    creator: "Ankur Warikoo",
    category: "Fiction",
    uploaded: "Oct 9 2021",
    comments: [
      {
        user: "Bablu Trailor",
        comment: "Your Future Is Created By What You Do Today, Not Tomorrow. ~ Rich Dad Poor Dad",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment:
          "This was also mine 1st financial book which i read and fall in love at the 1st sight. One of my best reads ever.",
        color: "brown",
      },
    ],
  },
  {
    _id: "SyQ4GGhRPQs",
    title: "Do Epic Shit Review",
    description:
      "About the book: Do Epic Shit by @warikoo  is a Self Help guide to becoming better at what you do / plan to do by learning from the mistakes that the author Ankur Warikoo has made in his professional and at time in his personal journey as well.",
    creator: "Brown Brainiac",
    category: "Self Help",
    uploaded: "Aug 12 2018",
    comments: [
      {
        user: "Bablu Trailor",
        comment:
          "I was searching for someone who will give honest review and Arihant sir you just came up with this video",
        color: "hotpink",
      },
      {
        user: "Roma Bulani",
        comment:
          "yesterday I was thinking to buy this book, and today your review popped up Thank u for this. warikoo sir and u both are great mentors ",
        color: "brown",
      },
    ],
  },
];
